<template>
  <div class="row">
    <a-card class="col-lg-12" style="border-radius: 10px;">
      <a-tabs>
        <a-tab-pane key="1" tab="Semua Pembelian" />
        <!-- <a-tab-pane key="2" tab="Menunggu Pembayaran" />
        <a-tab-pane key="3" tab="Pembelian Baru" />
        <a-tab-pane key="4" tab="Pembelian Dikirim" />
        <a-tab-pane key="5" tab="Pembelian Selesai" /> -->
        <a-button @click.prevent="$router.push({ name: 'purchase.create' })" type="primary" slot="tabBarExtraContent">
          Buat Pembelian
        </a-button>
      </a-tabs>
      <div class="row">
        <div class="col-md-4 mt-3">
          <a-form-item class="mb-0">
            <a-input-search
              placeholder="Order Number"
              @change="handleSearch"
              @pressEnter="handleSearchEnter"
            />
          </a-form-item>
        </div>
        <div class="col-md-4 mt-3">
          <a-form-item class="mb-0">
            <a-range-picker
              @change="handleSearchByDate"
            />
          </a-form-item>
        </div>
        <!-- <div class="col mt-2"> -->
          <TableList
            :list="dataTable"
            class="mt-2"
          />
        <!-- </div> -->
        <div class="col py-3 d-flex justify-content-end">
          <Pagination
            :total="purchase.pagination.totalRows"
            :pageSize="purchase.pagination.limit"
            :totalLengthPerPage="purchase.purchaseOrder.length"
            :defaultPage="purchase.pagination.page"
            @changePage="changePage"
          />
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TableList from '@/components/Purchase/TableList/index'
import Pagination from '@/components/Purchase/Pagination/index'

export default {
  name: 'component.purchase.index',
  components: {
    TableList,
    Pagination,
  },
  data: function () {
    return {
      page: 1,
      limit: 20,
      searchText: '',
      from_date: null,
      to_date: null,
    }
  },
  computed: {
    ...mapState(['purchase']),
    dataTable () {
      return this.purchase.purchaseOrder
    },
  },
  created () {
    this.fetchPurchase()
  },
  methods: {
    changePage (page) {
      this.page = page
      this.fetchPurchase()
    },
    handleSearch (e) {
      setTimeout(() => {
        this.searchText = e.target.value
        this.fetchPurchase()
      }, 1500)
    },
    handleSearchEnter (e) {
      this.searchText = e.target.value
      this.fetchPurchase()
    },
    handleSearchByDate (e) {
      if (e.length === 2) {
        const from = e[0] && `${this.$moment(e[0]).format('YYYY-MM-DD 00:00:00.001')}`
        const to = e[1] && `${this.$moment(e[1]).format('YYYY-MM-DD 23:59:00.000')}`

        this.from_date = this.$moment(from).format('YYYYMMDD')
        this.to_date = this.$moment(to).format('YYYYMMDD')
      } else {
        this.from_date = null
        this.to_date = null
      }

      this.fetchPurchase()
    },
    fetchPurchase () {
      this.$store.dispatch('purchase/GETPURCHASEORDER', {
        page: this.page,
        limit: this.limit,
        q: this.searchText ? this.searchText : undefined,
        from_date: this.from_date && this.to_date ? this.from_date : undefined,
        to_date: this.from_date && this.to_date ? this.to_date : undefined,
      })
    },
  },
}
</script>
